import { useEffect, useState } from 'react'
import { useGetQuery } from 'hooks'
import { Box } from '../box'
import { Container, Month, Day, Name, Empty } from './styles'

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const Events = ({ details }) => {
  const addressId = details?.address_id
  const url = addressId
    ? `/events?upcoming=true&address_id=${addressId}`
    : `/events?upcoming=true`

  const { data, reFetch } = useGetQuery({ url })
  const [index, setIndex] = useState(0)

  const loaded = data !== undefined
  const events = data?.events?.rows || []

  // Cycle through events every 30 seconds
  useEffect(() => {
    if (events.length <= 1) return
    const id = setInterval(() => {
      setIndex(i => (i + 1) % events.length)
    }, 30000)
    return () => clearInterval(id)
  }, [events.length])

  // Refresh event data every 5 minutes
  useEffect(() => {
    const id = setInterval(() => reFetch(true), 5 * 60 * 1000)
    return () => clearInterval(id)
  }, [])

  // Reset index if events list shrinks
  useEffect(() => {
    if (events.length > 0 && index >= events.length) setIndex(0)
  }, [events.length])

  if (!loaded) return <Box />

  if (events.length === 0) {
    return (
      <Box>
        <Empty>No upcoming events</Empty>
      </Box>
    )
  }

  const event = events[index]
  const date = new Date(event.start_time)
  const day = event.all_day ? date.getUTCDate() : date.getDate()
  const month = event.all_day ? MONTHS[date.getUTCMonth()] : MONTHS[date.getMonth()]

  return (
    <Box>
      <Container>
        <Month>{month}.</Month>
        <Day>{day}</Day>
        <Name>{event.name}</Name>
      </Container>
    </Box>
  )
}
